<mat-progress-bar *ngIf="_loading" mode="indeterminate" value="50"></mat-progress-bar>
<div class="panel setup-panel">
    <div class="row" *ngIf="!CheckStatus(14,3) && !CheckStatus(15,3)">
        <div class="setup-container _flex">
            <div class="box" (click)="go('./setup-undercarriage/on-equipment')">
                <div class="_white">
                    <img src="/Content/Images/undercarriage.jpg" width="200" alt="Setup system on equipment">
                </div>
                <div class="setup-box-content">
                    <span>Setup on equipment</span>
                </div>
            </div>
            <div class="box" (click)="go('./setup-undercarriage/in-inventory')">
                <div class="_white">
                    <img src="/Content/Images/inventory.jpg" width="200" alt="Setup system on equipment">
                </div>
                <div class="setup-box-content">
                    <span>Setup in inventory</span>
                </div>
            </div>
        </div>
    </div>
    <div>
        <setup-undercarriage-on-equipment *ngIf="CheckStatus(14,3)"></setup-undercarriage-on-equipment>
    </div>
    <div>
        <setup-undercarriage-in-inventory *ngIf="CheckStatus(15,3)"></setup-undercarriage-in-inventory>
    </div>
</div>
